import React from "react";

function Token() {
  return (
    <div>
      <section className="banner-sec pb-5 about-banner w-100 float-left ">
        <div className="wrapper2 padding-top">
          <div className="row align-items-center ">
            <div className="col-lg-6 order-lg-0 order-2">
              <div className="banner-left-sec">
                <h2
                  data-aos="fade-up"
                  data-aos-duration={600}
                  className="aos-init aos-animate"
                >
                  D Net Details
                </h2>
                <p className="text-white my-2">
                  <span className="font-weight-normal text-white">
                    {" "}
                    <b> Token Name</b> :{" "}
                  </span>{" "}
                  <span className="text-white ml-2">D Net</span>{" "}
                </p>
                <p className="text-white my-2">
                  <span className="font-weight-normal text-white">
                    {" "}
                    <b> Ticker</b> :{" "}
                  </span>{" "}
                  <span className="text-white ml-2">DNET</span>{" "}
                </p>
                <p className="text-white my-2">
                  <span className="font-weight-normal text-white">
                    {" "}
                    <b>Supply</b> :{" "}
                  </span>{" "}
                  <span className="text-white ml-2">999999999</span>{" "}
                </p>
                <p className="text-white my-2 ">
                  <span className="font-weight-normal text-white">
                    {" "}
                    <b>Technology</b> :{" "}
                  </span>
                  <span className="text-white  ml-2">Arbitrum</span>{" "}
                </p>
                <p className="text-white my-2 mb-5">
                  <span className="font-weight-normal text-white">
                    {" "}
                    <b>Contract</b> :{" "} 
                  </span>
                  <span className="text-white  ml-2"><a href="https://arbiscan.io/token/0x04c2b1ebc8b55b9810de905de7c3fe8181a9bcdf" target="_blank" rel="noopener noreferrer">0x04c2b1ebc8b55b9810de905de7c3fe8181a9bcdf</a></span>{" "}
                </p>

                <div className="d-flex ">
                  <a
                    className="button-1 px-5 my-2 my-lg-0"
                    href="#"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <div className="dots_border" />

                    <span className="text_button mb-0">Get Started</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="banner-right-sec">
                <video playsInline autoPlay loop muted className="w-100 h-100">
                  <source
                    src="../assets/images/img/token-details.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Token;
